import type { QueryClient } from '@tanstack/react-query';

export function refreshAfterWorkflowCancel(queryClient: QueryClient, projectId: string) {
  queryClient.invalidateQueries({ queryKey: ['campaign', projectId] });
  queryClient.invalidateQueries({ queryKey: ['campaigns'] });
  queryClient.invalidateQueries({ queryKey: ['activePlan'] });
  queryClient.invalidateQueries({ queryKey: ['panel-workflow-project', projectId] });
}

export function searchWithoutPlan(search: string): string | null {
  const params = new URLSearchParams(search);
  if (!params.has('planId') && !params.has('workflow')) return null;
  params.delete('planId');
  params.delete('workflow');
  const next = params.toString();
  return next ? `?${next}` : '';
}
